import * as $ from 'jquery';
import * as _ from 'underscore';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import BaseStore from '../BaseStore';
import { apiCall } from '../AqlUtility';
import { Constants } from './Constants';
import * as Utilities from '../Utilities';

import { Dispatcher } from './Dispatcher';
import { Action, Actions, I, check as checkAction } from './Actions';

//export const DEFAULT_MENU_NAME = 'Default';

export interface IGroup {
    groupName?: string;
    groupId?: number;
    displayName?: string;
    description?: string;
    membersList?: number[];
    //menuName?: string;
}

export interface IUser {
    displayName: string;
    Email: string;
    userid?: number;
    Login?: string;
    creationDate?: string;
    isActive?: boolean;
    isLockedOut?: boolean;
}

interface IUserUpdateParameters extends IUser {
    Password?: string;
    sendEmail?: boolean;
}

export interface IUsersHash {
    [id: number]: IUser;
}

export interface IUsersGroupState {
    loadingUsers: boolean;
    creatingUser: boolean;
    removingUsers: any;
    editingUsers: any;
    users: IUser[];
    usersHash: IUsersHash;

    loadingGroups: boolean;
    creatingGroup: boolean;
    removingGroups: any;
    editingGroups: any;
    groups: IGroup[];
    groupsHash: { [id: number]: IGroup };

    loadingGroupMembers: { [id: number]: boolean };
    groupMembers: { [id: number]: number[] };

    loadingUserMembers: { [id: number]: boolean };
    userMembers: any;
}

export class Store extends BaseStore<IUsersGroupState, Actions, Dispatcher, IGlob> {
    private static getInitialState() {
        return {
            loadingUsers: false,
            creatingUser: false,
            removingUsers: {},
            editingUsers: {},
            users: [],
            usersHash: {},

            loadingGroups: false,
            creatingGroup: false,
            removingGroups: {},
            editingGroups: {},
            groups: [],
            groupsHash: {},

            loadingGroupMembers: {},
            groupMembers: {},

            loadingUserMembers: {},
            userMembers: {}
        };
    }

    public _state: IUsersGroupState = Store.getInitialState();
    public static _name = 'users-groups-store';

    constructor(glob, dispatcher: Dispatcher, actions: Actions) {
        super(glob, dispatcher, actions, Store._name, true);
    }

    private usersLoaded: boolean = false;
    private groupsLoaded: boolean = false;

    private loadUsers(force = false) {
        if ((this.usersLoaded && !force) || this._state.loadingUsers) {
            return;
        }

        this._state.loadingUsers = true;

        apiCall(this.glob.AppActions, 'user_GetAllUsers', {})
            .done((resp: any) => {
                const users = Store.sortUserByDisplayName(resp.result);

                this._state.users = users;
                this._state.usersHash = _.indexBy(users, 'userid');

                this.actions.loadUsersFinish(true);
            })
            .fail((resp) => {
                this._state.users = [];
                this._state.usersHash = {};

                this.actions.loadUsersFinish(false);
            });
    }

    private static sortGroupByDisplayName(list: IGroup[]) {
        return Utilities.sortBy(list, 'displayName');
    }

    private static sortUserByDisplayName(list: IUser[]) {
        return Utilities.sortBy(list, 'displayName');
    }

    private loadUsersFinish(success) {
        this._state.loadingUsers = false;

        if (success) {
            this.usersLoaded = true;
        }
    }

    private createUser(
        _def: JQueryDeferred<any>,
        displayName: string,
        login: string,
        email: string,
        password: string,
        groupsList: any[],
        sendEmail?: boolean
    ) {
        if (this._state.creatingUser) {
            return;
        }

        this._state.creatingUser = true;

        const obj: IUserUpdateParameters = {
            displayName: displayName,
            Email: email
        };

        if (password != null && password.length > 0) {
            obj.Password = password;
        }

        if (obj.displayName && obj.displayName.toLowerCase() === 'anonymous') {
            obj.Login = 'anonymous';
        } else {
            if (login != null && login !== '') {
                obj.Login = login;
            }
        }

        if (sendEmail != null) {
            obj.sendEmail = sendEmail;
        }

        apiCall(this.glob.AppActions, 'user_Create', obj)
            .then(
                (resp) => {
                    const id = resp.result;
                    const def = apiCall(this.glob.AppActions, 'user_setGroupsForUser', {
                        UserId: id,
                        GroupList: groupsList
                    }).then(
                        () => {
                            return id;
                        },
                        (resp) => {
                            return resp;
                        }
                    );

                    return def;
                },

                (resp) => {
                    return resp;
                }
            )
            .done((id) => {
                if (id.result?.message?.length > 0) {
                    this.actions.createUserFinish(false);
                    _def.reject();
                } else {
                    delete obj.Password;

                    obj.userid = id;

                    this._state.users.push(obj);
                    this._state.usersHash[obj.userid] = obj;
                    this._state.users = Store.sortUserByDisplayName(this._state.users);

                    this.actions.createUserFinish(true);

                    this.glob.AppActions.notification('success', "User '" + displayName + "' was successfully created");

                    _def.resolve(id);
                }
            })
            .fail((resp) => {
                this.actions.createUserFinish(false);

                _def.reject();
            });
    }

    private createUserFinish(success) {
        this._state.creatingUser = false;

        if (success === true) {
            this.glob.AppActions.usersGroupsDataUpdated();
        }
    }

    private removeUser(id) {
        if (this._state.removingUsers[id] === true) {
            return;
        }

        this._state.removingUsers[id] = true;

        apiCall(this.glob.AppActions, 'user_Delete', {
            userid: id
        })
            .done((resp) => {
                this.actions.removeUserFinish(id, true);
            })
            .fail((resp) => {
                this.actions.removeUserFinish(id, false);
            });
    }

    private removeUserFinish(id, success) {
        this._state.removingUsers[id] = false;

        var find = _.find<any>(
            this._state.users,

            (user) => {
                return user.userid === id;
            }
        );

        if (success === true && find != null) {
            this._state.users = _.without(this._state.users, find);
            delete this._state.usersHash[id];
        }

        if (success === true) {
            this.glob.AppActions.usersGroupsDataUpdated();
            this.glob.AppActions.showNotification_Success("User with id'" + id + "' was successfully removed.");
        }
    }

    private editUser(_def, id, displayName, Login, Email, groupsList, Password) {
        if (this._state.editingUsers[id] === true) {
            return;
        }

        this._state.editingUsers[id] = true;

        const obj: IUserUpdateParameters = {
            userid: id,
            displayName: displayName,
            Email: Email
        };

        if (obj.displayName.toLowerCase() === 'anonymous') {
            obj.Login = 'anonymous';
        } else {
            if (Login != null && Login !== '') {
                obj.Login = Login;
            }
        }

        if (Password != null && Password !== '') {
            obj.Password = Password;
        }

        apiCall(this.glob.AppActions, 'user_update', obj)
            .then(
                (resp) => {
                    const def = apiCall(this.glob.AppActions, 'user_setGroupsForUser', {
                        UserId: id,
                        GroupList: groupsList
                    }).then(
                        () => {
                            return id;
                        },
                        (resp) => {
                            return resp;
                        }
                    );

                    return def;
                },
                (resp) => {
                    return resp;
                }
            )
            .done((resp) => {
                this.actions.editUserFinish(id, true, obj);

                _def.resolve();
            })
            .fail((resp) => {
                this.actions.editUserFinish(id, false, obj);

                _def.reject();
            });
    }

    private editUserFinish(id, success, user) {
        this._state.editingUsers[id] = false;

        const find = _.find(this._state.users, (user) => {
            return user.userid === id;
        });

        if (find != null) {
            _.extend(find, user);

            this._state.usersHash[id] = user;
            this._state.users = Store.sortUserByDisplayName(this._state.users);
        }

        if (success) {
            this.glob.AppActions.usersGroupsDataUpdated();
            this.glob.AppActions.showNotification_Success("User with id '" + id + "' was successfully updated");
        }
    }

    private recoverPassword(userid, name) {
        apiCall(this.glob.AppActions, 'user_RecoverPassword', {
            userid: userid
        })
            .done((resp) => {
                this.actions.recoverPasswordFinish(true, userid, name);
            })
            .fail((resp) => {
                this.actions.recoverPasswordFinish(false, userid, name);
            });
    }

    private recoverPasswordFinish(success, userid, name) {
        if (success) {
            this.glob.AppActions.showNotification_Success(
                `Password for user '${name}' was recovered. An email with additional information should be sent to user's address.`
            );
        }
    }

    private loadGroups(force = false) {
        if ((this.groupsLoaded && !force) || this._state.loadingGroups) {
            return;
        }

        this._state.loadingGroups = true;

        this.glob.AQLQueries.callMethod<IGroup[]>('user_getAllGroups', {})
            .done((resp) => {
                resp.result = Store.sortGroupByDisplayName(resp.result);

                this._state.groups = resp.result;
                this._state.groupsHash = _.indexBy(resp.result, 'groupId');

                this.actions.loadGroupsFinish(true);
            })
            .fail((resp) => {
                this._state.groups = [];
                this._state.groupsHash = {};

                this.actions.loadGroupsFinish(false);
            });
    }

    private loadGroupsFinish(success) {
        this._state.loadingGroups = false;

        if (success) {
            this.groupsLoaded = true;
        }
    }

    private getRequestGroupObj(name: string, description: string) {
        const result: any = {
            groupName: name
        };

        if (description != null) {
            result.description = description;
        }

        // if (menuName != null && menuName !== DEFAULT_MENU_NAME) {
        //     result.menuName = menuName;
        // }

        return result;
    }

    private createGroup(
        _def,
        name: string,
        members: any[],
        description: string
        //menuName: string
    ) {
        if (this._state.creatingGroup) {
            return;
        }

        this._state.creatingGroup = true;

        const obj = this.getRequestGroupObj(name, description);

        this.glob.AQLQueries.callMethod('user_createGroup', obj)
            .then(
                (resp) => {
                    const id = resp.result;

                    let def = this.glob.AQLQueries.callMethod('user_setGroupMembers', {
                        groupId: id,
                        memberList: members
                    });

                    def = def.then(
                        () => {
                            return id;
                        },
                        (resp) => {
                            return resp;
                        }
                    );

                    return def;
                },
                (resp) => {
                    return resp;
                }
            )
            .done((id) => {
                obj.groupId = id;
                obj.displayName = obj.groupName;
                delete obj.groupName;

                this._state.groups.push(obj);
                this._state.groupsHash[obj.groupId] = obj;
                this._state.groups = Store.sortGroupByDisplayName(this._state.groups);

                this.actions.createGroupFinish(true, name);

                _def.resolve();
            })
            .fail((resp) => {
                this.actions.createGroupFinish(false, name);

                _def.reject();
            });
    }

    private createGroupFinish(success, name) {
        this._state.creatingGroup = false;

        if (success === true) {
            this.glob.AppActions.usersGroupsDataUpdated();
            this.glob.AppActions.showNotification_Success("Group '" + name + "' was successfully created");
        }
    }

    private updateGroup(def: JQuery.Deferred<any>, id: number, name: string, members: any[], description: string) {
        if (this._state.editingGroups[id]) {
            return;
        }

        this._state.editingGroups[id] = true;

        const obj = this.getRequestGroupObj(name, description);

        obj.groupId = id;

        this.glob.AQLQueries.callMethod('user_updateGroup', obj)
            .then(
                (resp) => {
                    const def = this.glob.AQLQueries.callMethod('user_setGroupMembers', {
                        groupId: id,
                        memberList: members
                    }).then(
                        () => {
                            return id;
                        },
                        (resp) => {
                            return resp;
                        }
                    );

                    return def;
                },
                (resp) => {
                    return resp;
                }
            )
            .done((id: number) => {
                obj.displayName = obj.groupName;
                delete obj.groupName;

                this.actions.updateGroupFinish(id, true, name, obj);

                def.resolve();
            })
            .fail((resp) => {
                this.actions.updateGroupFinish(id, false, name);

                def.reject();
            });
    }

    private updateGroupFinish(id: number, success: boolean, name: string, obj) {
        this._state.editingGroups[id] = false;

        const group = _.find(this._state.groups, (group) => {
            return group.groupId === id;
        });

        if (group != null) {
            _.extend(group, obj);

            this._state.groupsHash[id] = group;
            this._state.groups = Store.sortGroupByDisplayName(this._state.groups);
            delete this._state.groupMembers[id];
        }

        if (success) {
            this.glob.AppActions.usersGroupsDataUpdated();
            this.glob.AppActions.showNotification_Success(`Group with name '${name}' was successfully updated`);
        }
    }

    private deleteGroup(id, name) {
        if (this._state.removingGroups[id] === true) {
            return;
        }

        this._state.removingGroups[id] = true;

        apiCall(this.glob.AppActions, 'user_deleteGroup', {
            groupId: id
        })
            .done((resp) => {
                this.actions.deleteGroupFinish(id, true, name);
            })
            .fail((resp) => {
                this.actions.deleteGroupFinish(id, false, name);
            });
    }

    private deleteGroupFinish(id, success, name) {
        this._state.removingGroups[id] = false;

        var find = _.find<any>(
            this._state.groups,

            (user) => {
                return user.groupId === id;
            }
        );

        if (success === true && find != null) {
            this._state.groups = _.without(this._state.groups, find);
            delete this._state.groupsHash[id];
        }

        if (success === true) {
            this.glob.AppActions.usersGroupsDataUpdated();
            this.glob.AppActions.showNotification_Success(`Group with name '${name}' was successfully removed`);
        }
    }

    private loadGroupMembers(id: number) {
        if (this._state.loadingGroupMembers[id]) {
            return false;
        }

        this._state.loadingGroupMembers[id] = true;
        delete this._state.groupMembers[id];

        apiCall(this.glob.AppActions, 'user_getGroupMembers', {
            groupId: id
        })
            .done((resp: any) => {
                this._state.groupMembers[id] = resp.result;
            })
            .fail((resp) => {
                delete this._state.groupMembers[id];
            })
            .always((resp) => {
                this.actions.loadGroupMembersFinish(id);
            });

        return true;
    }

    private loadGroupMembersFinish(id: number) {
        this._state.loadingGroupMembers[id] = false;
    }

    private loadUserMembers(id: number) {
        if (this._state.loadingUserMembers[id]) {
            return;
        }

        this._state.loadingUserMembers[id] = true;
        delete this._state.userMembers[id];

        apiCall(this.glob.AppActions, 'user_getGroupsForUser', {
            UserId: id
        })
            .done((resp) => {
                this._state.userMembers[id] = resp.result;
            })
            .fail((resp) => {
                delete this._state.userMembers[id];
            })
            .always((resp) => {
                this.actions.loadUserMembersFinish(id);
            });
    }

    private loadUserMembersFinish(id: number) {
        this._state.loadingUserMembers[id] = false;
    }

    private importADUsers(users) {
        apiCall(this.glob.AppActions, 'user_ImportADUsers', {
            userList: users
        }).done((resp) => {
            var count = resp.result;

            this.actions.importADUsersFinish(count);
        });
    }

    private importADUsersFinish(count) {
        if (count > 0) {
            this.actions.loadUsers(true);
        }

        this.glob.AppActions.showNotification_Success(count + ' AD accounts imported');
    }

    protected eventsHandler(payload) {
        if (!super.eventsHandler(payload)) {
            return false;
        }

        const action = payload.action;

        switch (action.actionType) {
            case Constants.LOAD_USERS:
                this.loadUsers(action.force);
                this.emitChange();
                break;

            case Constants.LOAD_USERS_FINISH:
                this.loadUsersFinish(action.success);
                this.emitChange();
                break;

            case Constants.CREATE_USER:
                this.createUser(
                    action.def,
                    action.displayName,
                    action.Login,
                    action.Email,
                    action.Password,
                    action.groupsList,
                    action.sendEmail
                );
                this.emitChange();
                break;

            case Constants.CREATE_USER_FINISH:
                this.createUserFinish(action.success);
                this.emitChange();
                break;

            case Constants.EDIT_USER:
                this.editUser(
                    action.def,
                    action.id,
                    action.displayName,
                    action.Login,
                    action.Email,
                    action.groupsList,
                    action.Password
                );
                this.emitChange();
                break;

            case Constants.EDIT_USER_FINISH:
                this.editUserFinish(action.id, action.success, action.user);
                this.emitChange();
                break;

            case Constants.REMOVE_USER:
                this.removeUser(action.id);
                this.emitChange();
                break;

            case Constants.REMOVE_USER_FINISH:
                this.removeUserFinish(action.id, action.success);
                this.emitChange();
                break;

            case Constants.RECOVER_PASSWORD:
                this.recoverPassword(action.userid, action.name);
                this.emitChange();
                break;

            case Constants.RECOVER_PASSWORD_FINISH:
                this.recoverPasswordFinish(action.success, action.userid, action.name);
                this.emitChange();
                break;

            case Constants.LOAD_GROUPS:
                this.loadGroups(action.force);
                this.emitChange();
                break;

            case Constants.LOAD_GROUPS_FINISH:
                this.loadGroupsFinish(action.success);
                this.emitChange();
                break;

            case Constants.CREATE_GROUP:
                this.createGroup(action.def, action.name, action.members, action.description);
                this.emitChange();
                break;

            case Constants.CREATE_GROUP_FINISH:
                this.createGroupFinish(action.success, action.name);
                this.emitChange();
                break;

            case Constants.UPDATE_GROUP:
                this.updateGroup(action.def, action.id, action.name, action.members, action.description);
                break;

            case Constants.UPDATE_GROUP_FINISH:
                this.updateGroupFinish(action.id, action.success, action.name, action.obj);
                this.emitChange();
                break;

            case Constants.DELETE_GROUP:
                this.deleteGroup(action.id, action.name);
                this.emitChange();
                break;

            case Constants.DELETE_GROUP_FINISH:
                this.deleteGroupFinish(action.id, action.success, action.name);
                this.emitChange();
                break;

            case Constants.LOAD_GROUP_MEMBERS:
                if (this.loadGroupMembers(action.id)) {
                    this.emitChange();
                }
                break;

            case Constants.LOAD_GROUP_MEMBERS_FINISH:
                this.loadGroupMembersFinish(action.id);
                this.emitChange();
                break;

            case Constants.LOAD_USER_MEMBERS:
                this.loadUserMembers(action.id);
                this.emitChange();
                break;

            case Constants.LOAD_USER_MEMBERS_FINISH:
                this.loadUserMembersFinish(action.id);
                this.emitChange();
                break;

            case Constants.IMPORT_AD_USERS:
                this.importADUsers(action.users);
                this.emitChange();
                break;

            case Constants.IMPORT_AD_USERS_FINISH:
                this.importADUsersFinish(action.count);
                this.emitChange();
                break;
        }

        return true;
    }

    public static get(glob, dispatcher: Dispatcher, actions: Actions) {
        return new Store(glob, dispatcher, actions);
    }

    public static init(glob: IGlob) {
        if (glob.UsersGroupsDispatcher == null) {
            glob.UsersGroupsDispatcher = Dispatcher.get();
        }

        if (glob.UsersGroupsActions == null) {
            glob.UsersGroupsActions = Actions.get(glob.UsersGroupsDispatcher);
        }

        if (glob.UsersGroupsStore == null) {
            glob.UsersGroupsStore = Store.get(glob, glob.UsersGroupsDispatcher, glob.UsersGroupsActions);
        }
    }
}
